// window.Mobile = Variável global setada pelo app Android na webview
// window.webkit = Variável global setada pelo app IOS

const ANDROID = 'android'
const IOS = 'ios'
const HYBRID = 'hybrid'
const REGISTRATION_COMPLETED = 'completed'
const RETURN_HOME = 'home'

const isiOSChrome = navigator.userAgent.match(/CriOS/i) !== null

const getAppType = () => {
  if (window.flutter_inappwebview) {
    return HYBRID
  } else if (window.Mobile) {
    return ANDROID
  } else {
    return IOS
  }
}

const isInApp = () =>
  window.Mobile ||
  (window.webkit && !isiOSChrome) ||
  window?.flutter_inappwebview

const isHybridApp = () => window?.flutter_inappwebview

const dispatchToMobile = (type) => {
  const appType = getAppType()
  sessionStorage.clear()
  switch (type) {
    case REGISTRATION_COMPLETED:
      if (appType === HYBRID) {
        window?.flutter_inappwebview?.callHandler('finishRegistration')
      } else if (appType === IOS) {
        window.webkit?.messageHandlers?.finishRegistration?.postMessage(
          'registration',
        )
      } else {
        window.Mobile.finishRegistration &&
          window.Mobile.finishRegistration(null)
      }
      break
    default:
      if (appType === HYBRID) {
        window?.flutter_inappwebview?.callHandler('returnHome')
      } else if (appType === IOS) {
        window.webkit?.messageHandlers?.returnHome?.postMessage('home')
      } else {
        window.Mobile?.returnHome && window?.Mobile?.returnHome(null)
      }
  }
}

export {
  dispatchToMobile,
  isInApp,
  isHybridApp,
  REGISTRATION_COMPLETED,
  RETURN_HOME,
}
